<template>
  <div class="CarItem" @click="onClick">
    <div :class="active ? 'aciveCarItem boxDiv' : 'boxDiv'">
      <img v-if="active" :src="iconSelect" class="selectStyle" alt="">
      <p class="carLength">{{filterName(item.name)}}</p>
      <p class="imgBox">
        <img class="carImage" :src="filterImg(item.name)" alt="">
      </p>
      <p class="carMsg"><span>载重{{item.weight/1000}}吨，容积{{item.volume}}方</span></p>
      <!-- <p><span :class="active ? 'radioBox active' : 'radioBox'"></span><span v-if="active" class="selectText">已选择</span></p> -->
    </div>
  </div>
</template>

<script>
import iconSelect from '@/assets/img/icon_select.png'
import carImg from './image'

const carTypeName = {
  ordinary: '普通厢式',
  cold: ''
}

export default {
  name: "CarItem",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    carNorms: {
      default: '',
      type: [String, Number]
    },
    item: {
      type: Object,
      default: ()=>{},
    }
  },
  data(){
    return {
      carImg,
      iconSelect,
    }
  },
  mounted(){
  },
  methods: {
    onClick(){
      this.$emit('click')
    },
    filterImg(item){
      const flag = true
        switch (flag) {
          case (item*1 < 5): 
            return this.filtercar() ? this.carImg.car42 : this.carImg.carcold42
          case (item*1 < 6): 
            return this.filtercar() ? this.carImg.car52 : this.carImg.carcold52
          case (item*1 < 7): 
            return this.filtercar() ? this.carImg.car68 : this.carImg.carcold68
          case (item*1 < 8): 
            return this.filtercar() ? this.carImg.car76 : this.carImg.carcold76
          case (item*1 < 9): 
            return this.filtercar() ? this.carImg.car86 : this.carImg.carcold86
          case (item*1 < 11): 
            return this.filtercar() ? this.carImg.car96 : this.carImg.carcold96
          case (item*1 < 100): 
            return this.filtercar() ? this.carImg.car165 : this.carImg.carcold165
          case (item === '依维柯'): 
            return this.carImg.yiweike
          case (item === '奶罐'): 
            return this.carImg.naiguan
          default :
            return this.carImg.mianbao
        }
    },
    filtercar(){
      return carTypeName.ordinary === this.carNorms
    },
    filterName(text){
      const number = parseFloat(text)
      if(number){
        const len = number.toString()
        if(len.includes('.')){
          return len.replace('.', '米')
        }
        return `${len}米`
      }
      return text
    }
  }
}
</script>

<style lang="less" scoped>
.CarItem{
  text-align: center;
  font-size: 14px;
  width: 16.6%;
  // padding: 8px 0;
  height: 169px;
  &:hover .boxDiv{
    border: 1px solid #2AD09C;
  }
  .boxDiv{
    display: inline-block;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid #F6F8FA;
    width: auto;
    padding: 4px;
    padding: 8px 16px 12px 15px;
  }
  .aciveCarItem{
    position: relative;
    box-shadow: 4px 8px 10px 0px rgba(204, 210, 212, 0.5);
    border-radius: 4px;
    background: #FFFFFF;
    border: 1px solid #06B880
  }
  p{
    // height: 20px;
    line-height: 20px;
  }
  .carLength{
    color: #06B880;
  }
  .imgBox{
    height: 100px;
  }
  .carImage{
    max-height: 110px;
    max-width: 100%;
  }
  .carMsg{
    span{
      display: inline-block;
      padding: 0 15px;
      background: rgba(50,50,51, 0.6);
      border-radius: 12px;
      font-size: 12px;
      margin-top: 4px;
      color: #ffffff;
    }
  }
  .radioBox{
    display: inline-block;
    width: 14px;
    height: 14px;
    background: #FFFFFF;
    border: 1px solid #D5D8DE;
    border-radius: 50%;
    vertical-align: middle;
  }
  .active{
    border: 5px solid #06B880;
  }
  .selectText{
    margin-left: 10px;
    color: #06B880;
  }
}
.selectStyle{
    position: absolute;
    right: 0;
    top: 0;
}
</style>